import $_request from '../../utils/request';
var state = {
    isViewContractDialog: false,
    isViewEditContractDialog: false,
    contractDetail: {},
    contractDetailVague: {},
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {
    GET_CONTRACTDETAIL: function (_a, params) {
        var commit = _a.commit;
        // 根据合同号获取合同详情
        var contractCode = params.contractCode, type = params.type, callback = params.callback;
        $_request({
            url: '/proxy/api/contract/get',
            method: 'post',
            data: {
                contractCode: contractCode,
            },
        }).then(function (res) {
            if (!res || res.errorCode)
                return;
            var data = res.data;
            commit('update', { contractDetail: data });
            type === 'view' && commit('update', { isViewContractDialog: true });
            type === 'edit' && commit('update', { isViewEditContractDialog: true });
            typeof callback === 'function' && callback(data);
        });
    },
    GET_CONTRACTDETAIL_VAGUE: function (_a, params) {
        // 根据不同的条件获取合同详情
        var criteria = params.criteria, callback = params.callback;
        $_request({
            url: '/proxy/api/contract/get/fuzzy',
            method: 'post',
            data: {
                criteria: criteria,
            },
        }).then(function (res) {
            if (!res || res.errorCode)
                return;
            var data = res.data;
            typeof callback === 'function' && callback(data);
        });
    },
};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
